export default __webpack_public_path__ + "static/ZMG_E-Paper-Qualitaeten2024-98f67189461ab997524aa8d80ea50f53.pdf";